// baseUrl.js

export const baseUrlProd = 'https://vtest-back.vercel.app/';
export const baseUrlDev = 'http://localhost:9000/';

// Choose which to use
export const baseUrl = baseUrlProd; // change this manually when needed
